export const ROSE_NO_BASKET_GREETING = "Hi I'm Rose. Where would you like to start?";
export const ROSE_BASKET_GREETING = "Let's get you another quote.";
export const messages = [];
export const CARD_SECTION_TOP_MARGIN = '52px';
export const CARD_SECTION_TOP_MARGIN_MOBILE = '40px';
export const CARD_MARGIN_BETWEEN = '16px';
export const CARD_WIDTH = '420px';
export const CARD_WIDTH_MOBILE = '100%';
export const CARD_WIDTH_TABLET = '100%';
export const TABLET_CARD_MARGIN_BETWEEN = '30px';
export const MOBILE_CARD_MARGIN_BETWEEN = '20px';
export const MOBILE_CARD_WIDTH = '100%';
export const TABLET_CARD_WIDTH = '310px';
export const CARD_HEIGHT = '80px';
